export default "__VITE_ASSET__C6umn0GE__"